<template>
  <div>
    <api-list type="itemsShippingHistory" :model="models.itemsShippingHistory" :quick-filters="quickFiltersSetup.itemsShippingHistory" :preFilters="[['items.item_id', 'eq', item.id]]" filter-on-mount no-querystring in-modal />
  </div>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ItemsShippingHistory',
  components: {
    ApiList
  },
  props: {
    item: {
      type: null,
      default: null,
      required: true
    }
  }
}
</script>
